module.exports = __webpack_public_path__ + "static/img/kp.739983d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/kp.png
// module id = ZvKa
// module chunks = 18